import { useEffect } from 'react'

export interface ShortcutHandlers {
  onNew?: () => void
  onRecalcAll?: () => void
  onExport?: () => void
  onImport?: () => void
  onSettings?: () => void
  onHelp?: () => void
}

/**
 * Single-key shortcuts. Ignored while typing in inputs, textareas or
 * contentEditable surfaces, and ignored when any modifier is held so the
 * browser's own shortcuts still work.
 *
 *  N  novo lançamento
 *  R  recalcular tudo
 *  E  exportar
 *  I  importar
 *  ,  configurações
 *  ?  esta ajuda
 */
export function useKeyboardShortcuts(handlers: ShortcutHandlers): void {
  useEffect(() => {
    const handler = (event: KeyboardEvent): void => {
      const target = event.target as HTMLElement | null
      if (isTextInput(target)) return
      if (event.metaKey || event.ctrlKey || event.altKey) return

      switch (event.key) {
        case 'n':
        case 'N':
          fire(event, handlers.onNew)
          break
        case 'r':
        case 'R':
          fire(event, handlers.onRecalcAll)
          break
        case 'e':
        case 'E':
          fire(event, handlers.onExport)
          break
        case 'i':
        case 'I':
          fire(event, handlers.onImport)
          break
        case ',':
          fire(event, handlers.onSettings)
          break
        case '?':
          fire(event, handlers.onHelp)
          break
      }
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [handlers])
}

function isTextInput(target: HTMLElement | null): boolean {
  if (!target) return false
  if (target.isContentEditable) return true
  const tag = target.tagName
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT'
}

function fire(event: KeyboardEvent, handler: (() => void) | undefined): void {
  if (!handler) return
  event.preventDefault()
  handler()
}
